import tmdb from './client';

const Toprate = (page, config = {}) =>
  tmdb.get('/movie/top_rated', {
    ...config,
    params: { language: 'en-US', page, ...(config.params || {}) },
  });

export default Toprate;
